<template>
	<div class="question-container">
		<div>
			<div
				class="question-text"
				v-for="(question, index) in data.question.getQuestion()"
				v-html="question"
				:key="index"
			></div>
			<div
				class="note-text"
				:style="{ color: theme.lightMainTextColor }"
				v-for="(note, index) in data.question.getNotes()"
				v-html="note"
				:key="index + 100"
			></div>
			<div class="multi-button-answer">
				<button
					class="button"
					v-for="answer in data.question.getAnswers()"
					:key="answer.label"
					:style="{
						background: theme[answer.style.background],
						color: theme[answer.style.text],
					}"
					@click="answer.actions(answer.label, [], data.question, toggleLoading, saveApplicationAction)"
				>
					{{ data.question.getLocalizationDisplay(answer.label, data.language) }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'QuestionMultiButtons',
		props: ['theme', 'data', 'questionKey', 'toggleLoading', 'saveApplicationAction'],
		data() {
			return {
				answer: null,
			};
		},
		computed: {},
		created() {
			this.$watch(
				() => this.data.language,
				newValue => {
					this.data.question.customerApp().quoteAppData.changeLanguage(newValue);
				},
				{ deep: true },
			);
		},

		methods: {},
		components: {},
	};
</script>

<style></style>
